import React from "react";
import {
  Box,
  Checkbox,
  TextField,
  InputAdornment,
  FormControlLabel
} from '@mui/material';
import SearchSvg from '../../../../assets/images/smallSearch.svg';
import DosenButton from "../../../../components/ui/Buttons/DosenButton";

const SearchIcon = () => <img src={SearchSvg} alt="Search Icon" width={16} height={16} />;

interface FilterCheckFieldProps {
    index?: number;
    label?: string;
    onChange?: (value: string) => void;
    checked?: boolean;
    width?: string; // Add width prop
}

interface FilterSearchProps {
  userTypeDate: {
    placeholderText: string;
  };
  value: string | string[];
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  width?: string; // Add width prop
}

/** Checkbox field */
export const FilterCheckField: React.FC<FilterCheckFieldProps> = ({ index, label, onChange, checked, width }) => {
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <FormControlLabel
        key={index}
        sx={{ width: width || '100%', justifyContent: 'space-between', ml: '0' }}
        value={label}
        control={
          <Checkbox 
              onChange={handleCheckboxChange}
              checked={checked}
          />
        }
        label={label}
        labelPlacement="start"
    />
  );
};

/** Search field */
export const FilterSearch: React.FC<FilterSearchProps> = (props) => {
  const { userTypeDate, value, onChange, width } = props;

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event);
  };

  return (
    <Box
      sx={{
        width: width || '100%',
        background: 'var(--Fill-background, #0F0F0F)',
        border: '1px solid var(--Stroke-table-primary, #2A2A2A)',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 1,
        py: 0.5
      }}
    >
      <TextField
        size="small"
        placeholder={userTypeDate.placeholderText}
        value={value}
        onChange={handleInputChange}
        variant="standard"
        fullWidth
        InputProps={{
          disableUnderline: true,
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          )
        }}
        sx={{
          '& .MuiInputBase-input': {
            color: 'var(--Text-text-primary, #FDFDFD)',
            fontSize: '13px'
          },
          '& .MuiInputBase-root': {
            fontFamily: "'Inter', sans-serif"
          }
        }}
      />
      <DosenButton
        size="small"
        tone="basic"
        sx={{
          textTransform: 'none',
          px: 2
        }}
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        Filter
      </DosenButton>
    </Box>
  );
};
